<template>
  <div class="my_bussiness">
    <el-divider content-position="left">商机管理</el-divider>
    <el-collapse v-model="activeOpen">
      <el-collapse-item title="高级筛选" name="1">
        <div class="changeHeight m-tabs-content">
          <el-row :gutter="20">
            <el-col :span="2" class="tr m-label text_right">公司名称</el-col>
            <el-col :span="5">
              <el-select
                v-model="searchArr.company_id"
                filterable
                remote
                reserve-keyword
                placeholder="请输入公司字号筛选公司"
                size="mini"
                clearable
                :remote-method="remoteMethod"
                :loading="loading"
              >
                <el-option
                  v-for="company in companies"
                  :key="company.id"
                  :label="company.company_name"
                  :value="company.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2" class="tr m-label text_right">商机所属人</el-col>
            <el-col :span="5">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.uid"
                placeholder="请选择商机所属人"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
            <el-col :span="2" class="tr m-label text_right">商机创建人</el-col>
            <el-col :span="5">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.created_uid"
                placeholder="请选择商机创建人"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              <!-- <el-select
                  :filterable="true"
                  collapse-tags
                  v-model="searchArr.created_uid"
                  placeholder="请选择商机创建人"
                  size="mini"  clearable>
                  <el-option
                    v-for="item in users"
                    :key="item.id"
                    :value="item.id"
                    :label="item.username">
                  </el-option>
                </el-select> -->
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="2" class="tr m-label text_right">创建时间</el-col>
            <el-col :span="5">
              <div>
                <el-date-picker
                  v-model="searchArr.created_at"
                  type="date"
                  size="mini"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  @change="pickerDataChange"
                  placeholder="选择商机创建时间"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="2" class="tr m-label text_right">紧急程度</el-col>
            <el-col :span="5">
              <el-select v-model="searchArr.urgency" size="mini">
                <el-option label="普通" :value="1">普通</el-option>
                <el-option label="紧急" :value="2">紧急</el-option>
                <el-option label="重要" :value="3">重要</el-option>
                <el-option label="特殊" :value="4">特殊</el-option>
              </el-select>
            </el-col>
            <el-col :span="2" class="tr m-label text_right">商机状态</el-col>
            <el-col :span="5">
              <el-select v-model="searchArr.status" size="mini">
                <el-option label="无人处理" :value="1">无人处理</el-option>
                <el-option label="正在接触" :value="2">正在接触</el-option>
                <el-option label="流失放弃" :value="3">流失放弃</el-option>
                <el-option label="已经成交" :value="4">已经成交</el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="tr">
              <el-button type="primary" size="mini" @click="handleASearSub"
                >查询</el-button
              >
              <el-button type="danger" size="mini" @click="handleCloseSearch"
                >清除</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-row class="mb-10">
      <el-col :span="5" style="float: right" class="tr"> </el-col>
    </el-row>
    <el-table
      :data="my_bussiness"
      size="medium"
      style="width: 100%; margin-top: 0.2rem"
      v-cloak
      border
    >
      <el-table-column fixed label="公司名称" width="300">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.company_name ? scope.row.company_name.company_name : ''"
            placement="right"
            style="display: inline-block; vertical-align: middle"
          >
            <div class="company_hover">
              <span class="count_style" style="display: inherit">
                <el-link type="primary" @click="handleGetChangeDetail(scope.row.id)">{{
                  scope.row.company_name ? scope.row.company_name.company_name : ""
                }}</el-link>
                <!-- {{scope.row.company_name ? scope.row.company_name.company_name : ''}} -->
              </span>
            </div>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="复制" placement="top"
            ><i
              class="el-icon-document-copy"
              style="
                margin-left: 0.1rem;
                cursor: pointer;
                display: inline-block;
                vertical-align: middle;
              "
              @click="copySome(scope.row.company_name.company_name)"
            ></i
          ></el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed label="创建时间" width="140" prop="created_at">
        <template slot-scope="scope">
          <date-formatter :date-value="scope.row.created_at"></date-formatter>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        label="负责人"
        width="120"
        prop="change_user.username"
      ></el-table-column>
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        width="150"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="item.prop === 'remark'"
            :content="scope.row.remark"
            placement="top"
          >
            <span class="count_style">{{ scope.row[item.prop] }}</span>
          </el-tooltip>
          <el-tooltip
            v-else-if="item.prop === 'create_user'"
            :content="scope.row[item.prop] ? scope.row[item.prop].username : ''"
            placement="top"
          >
            <span class="count_style" style="display: inherit">{{
              scope.row[item.prop] ? scope.row[item.prop].username : ""
            }}</span>
          </el-tooltip>
          <el-tooltip
            v-else-if="item.prop === 'order_num'"
            :content="scope.row[item.prop] ? scope.row[item.prop].order_num : ''"
            placement="top"
          >
            <span class="count_style" style="display: inherit">{{
              scope.row[item.prop] ? scope.row[item.prop].order_num : ""
            }}</span>
          </el-tooltip>
          <el-tooltip v-else :content="scope.row[item.prop]" placement="top">
            <span class="count-style">{{ scope.row[item.prop] }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="80">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="商机情况" placement="top">
            <el-button
              type="success"
              size="mini"
              icon="el-icon-document"
              @click="handleSuccessChange(scope.row.id)"
              circle
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="tr mt-10"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <el-drawer title="商机情况" :visible.sync="upDrawer" direction="rtl" size="35%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-tabs style="padding: 0 0.2rem 0 0.4rem" v-model="activeName">
          <el-tab-pane label="操作记录" name="first">
            <div class="blocka">
              <el-timeline>
                <el-timeline-item
                  v-for="(OperationRecord, index) in OperationRecord"
                  :key="index"
                  :timestamp="OperationRecord.created_at"
                  placement="top"
                >
                  <el-card>
                    <p>{{ OperationRecord.operate }}</p>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-tab-pane>
          <el-tab-pane label="反馈记录" name="second">
            <div class="blocka">
              <el-timeline>
                <el-timeline-item
                  v-for="(returnRecord, index) in returnRecord"
                  :key="index"
                  :timestamp="returnRecord.created_at"
                  placement="top"
                >
                  <el-card v-if="returnRecord">
                    <p>
                      {{
                        returnRecord.return_user
                          ? returnRecord.return_user.username
                          : "" + "的反馈："
                      }}
                    </p>
                    <el-tooltip
                      class="item"
                      :content="returnRecord.return_content"
                      placement="top"
                    >
                      <p class="count_style">{{ returnRecord.return_content }}</p>
                    </el-tooltip>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <el-drawer
      title="详细信息"
      :visible.sync="detailDrawer"
      direction="rtl"
      :before-close="handleUpBeforeClose"
      size="35%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-tabs style="padding: 0 0.2rem 0 0.4rem" v-model="activeName">
          <el-tab-pane label="商机信息" name="first">
            <el-row>
              <el-col :span="6">公司名称:</el-col>
              <el-col :span="18">{{
                detailData.company_name ? detailData.company_name.company_name : ""
              }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="6">法人名称:</el-col>
              <el-col :span="18">{{
                detailData.company_name ? detailData.company_name.legaler : ""
              }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="6">联系方式:</el-col>
              <el-col :span="18">{{
                detailData.company_name ? detailData.company_name.legaler_contact : ""
              }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="6">企业税号:</el-col>
              <el-col :span="18">{{
                detailData.company_name ? detailData.company_name.taxNumber : ""
              }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="6">经营状态:</el-col>
              <el-col :span="18">{{
                detailData.company_name ? detailData.company_name.regStatus : ""
              }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="6">主要业务:</el-col>
              <el-col :span="18">{{
                detailData.company_name ? detailData.company_name.trade : ""
              }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="6">创建时间:</el-col>
              <el-col :span="18">{{ detailData.created_at }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="6">紧急程度:</el-col>
              <el-col :span="18">{{ detailData.urgency }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="6">线索状态:</el-col>
              <el-col :span="18">{{ detailData.status }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="6">创建人:</el-col>
              <el-col :span="18">{{
                detailData.create_user ? detailData.create_user.username : ""
              }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="6">成交时间:</el-col>
              <el-col :span="18">{{ detailData.success_at }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="6">成交订单号:</el-col>
              <el-col :span="18">{{
                detailData.order_num ? detailData.order_num.order_num : ""
              }}</el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import DateFormatter from "common/DateFormatter";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "MyBussiness",
  components: { DateFormatter },
  data() {
    return {
      activeOpen: "",
      inputSize: "small",
      users: [],
      contents: [],
      companies: [],
      my_bussiness: [],
      returnRecord: [],
      OperationRecord: [],
      bussiness_content: [],
      loading: false,
      addDrawer: false,
      upDrawer: false,
      detailDrawer: false,
      user_id: null,
      order_id: "",
      change_id: "",
      orderNums: [],
      detailData: [],
      activeName: "first",
      dialogSuccess: false,
      textareaSize2: {
        minRows: 2,
        maxRows: 4,
      },
      col: [
        {
          label: "紧急程度",
          prop: "urgency",
          display: false,
        },
        {
          label: "商机状态",
          prop: "status",
          display: false,
        },
        {
          label: "创建人",
          prop: "create_user",
          display: false,
        },
        // {
        //   label: '商机内容',
        //   prop: 'bussin_content',
        //   display: false
        // },
        {
          label: "获取商机时间",
          prop: "get_bussin_at",
          display: false,
        },
        {
          label: "成交单号",
          prop: "order_num",
          display: false,
        },
        {
          label: "成交时间",
          prop: "success_at",
          display: false,
        },
        {
          label: "最后建议时间",
          prop: "last_suggest_at",
          display: false,
        },
        {
          label: "备注",
          prop: "remark",
          display: false,
        },
      ],
      addData: {
        company_id: "",
        bussin_content: [],
        urgency: 1,
        remark: "",
        uid: "",
      },
      searchArr: {
        uid: "",
        company_id: "",
        created_uid: "",
        urgency: "",
        status: "",
        created_at: "",
      },
      upData: {
        id: null,
        index: null,
        bussin_content: [],
        urgency: "",
        remark: "",
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 10, // 每页显示条数
      },
    };
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    getBussinChangeData() {
      this.$axios
        .get(
          "/api/bussin_change/bussin_manage?page=" +
            this.pageOption.currentPage +
            '&pageSize=' + this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.my_bussiness = data.data.list.data;
            this.users = data.data.users;
            this.contents = data.data.contents;
            this.user_id = data.data.user_id;
            this.bussiness_content = data.data.bussiness_content;
            this.pageOption.total = data.data.list.total;
            this.pageOption.currentPage = data.data.list.current_page;
          }
        });
    },
    handleAddSave() {
      if (!this.addData.company_id) {
        this.$message.error("公司不能为空");
        return;
      }
      if (!this.addData.bussin_content) {
        this.$message.error("商机内容不能为空");
        return;
      }
      if (!this.addData.urgency) {
        this.$message.error("商机紧急程度不能为空");
        return;
      }
      this.$axios.post("/api/bussin_change", this.addData).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.getBussinChangeData();
          this.addDrawer = false;
          this.clearAdd();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    SaveChangeMethods(field, fieldName) {
      let oldValue = null;
      if (field === "bussin_content") {
        oldValue = this.getContentIds(
          this.my_bussiness[this.upData.index].bussin_contents
        );
      } else {
        oldValue = this.my_bussiness[this.upData.index][field];
      }
      this.$axios
        .put("/api/bussin_change/" + this.upData.id, {
          fieldName: field,
          value: this.upData[field],
          old: oldValue,
          typeName: fieldName,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.getBussinChangeData();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleGiveUpChange(id) {
      this.$axios.put("/api/bussin_change/give_up/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.getBussinChangeData();
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleSuccessOrderId() {
      this.$axios
        .put("/api/bussin_change/success/" + this.change_id, { order_id: this.order_id })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.getBussinChangeData();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    getDetailData(id) {
      this.$axios.put("/api/bussin_change/detail/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.detailData = data.data.detail;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    searchOrders(query) {
      this.$axios.get("/api/admin/searchOrders?num=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.orderNums = data.data.orderNum;
        }
      });
    },
    getOperateData(id) {
      this.$axios.get("/api/bussin_change/operate/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.OperationRecord = data.data.operates;
          this.returnRecord = data.data.returns;
        }
      });
    },
    handleASearSub() {
      this.activeOpen = "";
      this.pageOption.currentPage = 1;
      this.getBussinChangeData();
    },
    handleCloseSearch() {
      this.searchArr.uid = "";
      this.searchArr.created_uid = "";
      this.searchArr.company_id = "";
      this.searchArr.urgency = "";
      this.searchArr.status = "";
      this.searchArr.created_at = "";
      this.activeOpen = "";
      this.getBussinChangeData();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getBussinChangeData();
    },
    pickerDataChange(val) {
      if (!val) {
        this.searchArr.created_at = "";
      } else {
        this.searchArr.created_at = val;
      }
    },
    handleAddOpen() {
      this.addDrawer = true;
    },
    handleSuccessChange(id) {
      this.change_id = id;
      this.getOperateData(id);
      this.upDrawer = true;
    },
    handleGetChangeDetail(id) {
      this.getDetailData(id);
      this.detailDrawer = true;
    },
    clearAdd() {
      this.addData.uid = "";
      this.addData.urgency = 1;
      this.addData.company_id = "";
      this.addData.bussin_content = [];
      this.addData.remark = "";
    },
    clearUpdata() {
      this.addData.id = null;
      this.addData.index = null;
      this.addData.urgency = 1;
      this.addData.bussin_content = [];
      this.addData.remark = "";
    },
    handleUpBeforeClose(done) {
      this.clearUpdata();
      done();
    },
    getContentIds(contents) {
      let content = [];
      if (contents.length <= 0) {
        return content;
      }

      for (var i = 0; i < contents.length; i++) {
        content.push(contents[i].pivot.content_id);
      }

      return content;
    },
    handleContactOpen(index, row) {
      this.upData.id = row.id;
      this.upData.index = index;
      this.upData.company_id = row.company_id;
      this.upData.remark = row.remark;
      this.upData.uid = row.uid;
      this.upData.bussin_content = this.getContentIds(row.bussin_contents);
      this.upData.urgency = this.getUrgencyValue(row.urgency);
      this.upDrawer = true;
    },
    getUrgencyValue(value) {
      let arr = ["", "普通", "紧急", "重要", "特殊"];
      for (let key in arr) {
        if (value === arr[key]) {
          return key;
        }
      }
    },
    handleAddBeforeClose(done) {
      this.clearAdd();
      done();
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    remoteOrderMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchOrders(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    handleClose(done) {
      this.order_id = "";
      this.change_id = "";
      done();
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  mounted() {
    this.getBussinChangeData();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
};
</script>
<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
@import '~styles/icon.styl'
[v-cloak]
  display: none
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.el-select
  width: 100%
.my_bussiness >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.my_bussiness
  marginLeft()
  .count_style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.search-row .el-col
  margin-bottom: .2rem
.tr
  text-align: right
.mt-10
  margin-top: .2rem
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
.el-date-editor
  width: 100%
</style>



// WEBPACK FOOTER //
// src/pages/bussiness_manage/BussinessManage.vue